import React from "react";
import { IDatabaseLineItem } from "../../LineItemDBCreationToolPage";
import { LineItemOrderObject } from "../../../types";

export interface CatLineItemRowProps {
	orderItem: LineItemOrderObject;
	displayIndex: number;
	groupCat: string;
	lineItem: IDatabaseLineItem | undefined;
	isBeingDragged: boolean;
	isSelected: boolean;
	onDragStart: (e: React.DragEvent, item: LineItemOrderObject, cat: string) => void;
	onDragOver: (e: React.DragEvent) => void;
	onDrop: (e: React.DragEvent, item: LineItemOrderObject, cat: string) => void;
	onDragEnd: () => void;
	onClick: (e: React.MouseEvent, item: LineItemOrderObject) => void;
}

const CatLineItemRow: React.FC<CatLineItemRowProps> = ({
	orderItem,
	displayIndex,
	groupCat,
	lineItem,
	isBeingDragged,
	isSelected,
	onDragStart,
	onDragOver,
	onDrop,
	onDragEnd,
	onClick,
}) => (
	<tr
		draggable
		onDragStart={(e) => onDragStart(e, orderItem, groupCat)}
		onDragOver={onDragOver}
		onDrop={(e) => onDrop(e, orderItem, groupCat)}
		onDragEnd={onDragEnd}
		onClick={(e) => onClick(e, orderItem)}
		className={`cursor-move transition-colors select-none ${isBeingDragged ? "opacity-50" : ""} ${
			isSelected ? "bg-blue-50 border-l-2 border-blue-400" : "hover:bg-gray-50"
		}`}
	>
		<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 pl-12">{displayIndex}</td>
		<td className="px-6 py-4 text-sm text-gray-900">{lineItem?.originalLineItem || orderItem.lineItemId}</td>
	</tr>
);

export default CatLineItemRow;
